module.exports = __webpack_public_path__ + "img/Juan-Guarnizo.88a50e1e.png";